import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import { ProductActions, ProductSearchPage } from '@spartacus/core';
import { ProductListComponentService, ProductScrollComponent, ViewConfig, ViewModes } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { ComponentService } from '../../../../../../service/component.service';

@Component({
  selector: 'app-shimano-product-scroll',
  templateUrl: './shimano-product-scroll.component.html',
  standalone: false,
})
export class ShimanoProductScrollComponent extends ProductScrollComponent implements OnInit, OnDestroy {
  @Input('scrollConfig')
  set setConfig(inputConfig: ViewConfig) {
    // @ts-ignore
    this.setComponentConfigurations(inputConfig);
  }

  model: ProductSearchPage;
  @Input('model')
  set setModel(inputModel: ProductSearchPage) {
    // @ts-ignore
    this.infiniteScrollOperations(inputModel);
  }

  inputViewMode: ViewModes;
  @Input('inputViewMode')
  set setViewMode(inputViewMode: ViewModes) {
    this.inputViewMode = inputViewMode;
    // If viewMode is already set (meaning it is not the first load)
    // Reset the product list
    if (this.viewMode) {
      // @ts-ignore
      this.resetListOnViewModeChange();
    } else {
      // If viewMode is not set (meaning it is the first load)
      // Set the viewMode
      this.viewMode = inputViewMode;
    }
  }

  // to get the updated productListResults
  @Input() productListResults: any;

  @Input() cachedlastPage: number;
  @Input() isCachedLastPage: boolean;

  viewMode: ViewModes;
  productLimit: number;
  maxProducts: number;

  ViewModes = ViewModes;
  appendProducts = false;
  resetList = false;
  isMaxProducts = false;
  isLastPage = false;
  isEmpty = false;
  basepriceBehaviorConfig$: Subscription;
  basepriceBehavior = false;
  searchDone = true;
  searchSubscription$: Subscription;
  searchDoneSubscription$: Subscription;

  constructor(
    productListComponentService: ProductListComponentService,
    ref: ChangeDetectorRef,
    private baseproductListComponentService: ProductListComponentService,
    private baseref: ChangeDetectorRef,
    private componentService: ComponentService,
    private dealerPriceService: DealerPriceService,
    private cdr: ChangeDetectorRef,
    private actionsSubject: ActionsSubject
  ) {
    super(productListComponentService, ref);
  }

  ngOnInit() {
    this.basepriceBehaviorConfig$ = this.dealerPriceService.getBasepriceBehavior$().subscribe((hideBaseprice: any) => {
      if (hideBaseprice === 'true') {
        this.basepriceBehavior = true;
      } else {
        this.basepriceBehavior = false;
      }
      this.cdr.detectChanges();
    });

    this.watchSearchAPISuccess();
  }

  scrollPage(pageNumber: number): void {
    if (this.searchDone) {
      pageNumber = this.cachedlastPage ? this.cachedlastPage + 1 : pageNumber;
      this.appendProducts = true;
      this.componentService.plpAppendProducts$.next(this.appendProducts);
      this.baseref.markForCheck();
      this.baseproductListComponentService.getPageItems(pageNumber);
    }
  }

  watchSearchAPISuccess(): any {
    this.searchSubscription$ = this.actionsSubject
      .pipe(ofType(ProductActions.SEARCH_PRODUCTS))
      .subscribe(() => (this.searchDone = false));
    this.searchDoneSubscription$ = this.actionsSubject
      .pipe(ofType(ProductActions.SEARCH_PRODUCTS_SUCCESS, ProductActions.SEARCH_PRODUCTS_FAIL))
      .subscribe(() => (this.searchDone = true));
  }

  loadNextPage(pageNumber: number): void {
    this.isMaxProducts = false;
    this.scrollPage(pageNumber);
  }

  scrollToTop(): void {
    window.scroll(0, 0);
  }

  ngOnDestroy(): void {
    this.componentService.plpAppendProducts$.next(false);
    if (this.basepriceBehaviorConfig$) {
      this.basepriceBehaviorConfig$.unsubscribe();
    }
    this.searchSubscription$?.unsubscribe();
    this.searchDoneSubscription$?.unsubscribe();
  }
}
